<!--C2-迭代需求 #42892（分期计算器H5设计）-->
<template>
  <div class="tr-box flex">
    <div class="tr-title flex">
      <span>{{ title }}</span>
    </div>
    <div :class="['tr-content', 'flex', name ? 'tr-deep' : '']">
      <div>
        <slot></slot>
      </div>
      <div v-if="name" :class="{'selector':true, 'flex':true, 'manual-input':selectVisible}" @click="showPicker">
        <div>{{ value }}{{ unit }}</div>
        <img v-show="!selectVisible"
          src="../../../assets/image/VcarCalculator/selector.png"
          class="selector-btn"
        />
      </div>
    </div>
    <vcar-popup @close="closePicker" :visible="visible">
      <div class="van-picker-content">
        <van-picker
          show-toolbar
          :columns="columns"
          :default-index="valueIndex"
          @confirm="onConfirm"
          @cancel="closePicker"
        />
      </div>
    </vcar-popup>
  </div>
</template>

<script>
import VcarPopup from "./VcarPopup";
import { Picker } from "vant";

export default {
  data() {
    return {
      visible: false,
      valueIndex: 0,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: null,
    },
    unit: {
      type: String,
      default: "",
    },
    columns: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    selectVisible:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.setIndexByValue(newValue);
    },
  },
  components: {
    "van-picker": Picker,
    VcarPopup,
  },
  methods: {
    showPicker() {
      if(this.selectVisible) {
        return
      }
      this.visible = true;
    },
    closePicker() {
      this.visible = false;
    },
    onConfirm(val) {
      this.onChange(val);
    },
    onChange(val) {
      this.$emit("change", val);
      this.closePicker();
    },
    setIndexByValue(val) {
      const { columns = [] } = this;
      let idx = 0;
      for (let i = 0; i < columns.length; i++) {
        if (Number(val) === Number(columns[i])) {
          idx = i;
          break;
        }
      }
      this.valueIndex = idx;
    },
  },
};
</script>

<style scoped>
.flex {
  display: -moz-box;
  /* Firefox */
  display: -ms-flexbox;
  /* IE10 */
  display: -webkit-box;
  /* Safari */
  display: -webkit-flex;
  /* Chrome, WebKit */
  display: box;
  display: flexbox;
  display: flex;
}

.tr-box {
  width: 100%;
  min-height: 0.9rem;
  margin-top: 0.04rem;
}

.tr-box:first-child {
  margin-top: 0px;
}

.tr-box .tr-title {
  width: 1.28rem;
  min-width: 1.28rem;
  min-height: 100%;
  background-color: #f1f2f3;
  font-family: PingFangSC-Regular;
  font-size: 0.28rem;
  color: #858689;
  letter-spacing: 0;
  line-height: 1;
  align-items: center;
  justify-content: center;
}

.tr-box .tr-content {
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
  background-color: #f1f2f3;
  margin-left: 0.04rem;
  position: relative;
  padding: 0.3rem 0.3rem 0.35rem 0.3rem;
  font-family: PingFangSC-Medium;
  font-size: 0.3rem;
  color: #333333;
  letter-spacing: 0;
  line-height: 1;
}

.tr-box:first-child .tr-content {
  flex-direction: column;
  padding: 0.34rem 0.3rem 0.19rem;
  align-items: flex-start;
  justify-content: flex-start;
}

.tr-box .tr-deep {
  background-color: #e5e9f2;
}

.tr-box .tr-content .manual-input {
  width: 1.08rem;
  height: 0.44rem;
  line-height: 0.44rem;
}
.tr-box .tr-content > div:first-child {
  padding-right: 16px;
}

.tr-box .tr-content input {
  /*height: 0.44rem*/
}

.tr-box .tr-content .selector {
  align-items: center;
}

.tr-box .tr-content .selector .selector-btn {
  margin-left: 0.26rem;
  width: 0.44rem;
  height: 0.44rem;
  cursor: pointer;
}

.van-picker-box {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.12);
  flex-direction: column;
  justify-content: flex-end;
}

.van-picker-box .van-picker-content {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/VcarCalculator/components/VcarTr.vue